import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from "../../images/morjor_logo.png";
import { Formik } from "formik";
import { useMutation, useLazyQuery } from "@apollo/react-hooks";
import { BrowserView, MobileView } from "react-device-detect";
import useReactRouter from "use-react-router";
import { USER_DATA_KEY, USER_KEY } from "../../consts/index";
import { LOGIN } from "../../apollo/studentAuth";
import pngkit_call from "../../images/pngkit_call.png";
import { Button, Form, Row, Col, Modal } from "react-bootstrap";
import Loading from "../../common/Loading";
import { faSignInAlt, faUser } from "@fortawesome/free-solid-svg-icons";
import { STUDENTS } from "../../apollo/students";
import { assessmentYearNow } from "../../consts/assessmentYear";

function Form_login() {
  const { history } = useReactRouter();
  const [errorMessage, setErrorMessage] = useState("");
  const [errorStudentType, setErrorStudentType] = useState(false);
  const [showDanger, setShowDanger] = useState(false);
  const [showModalMobile, setShowModalMobile] = useState(false);
  const [phone, setPhone] = useState();
  const [code, setCode] = useState();

  const [loginType, setLoginType] = useState("PHONE");
  const [isLoading, setIsLoading] = useState(false);
  const [login] = useMutation(LOGIN);
  const [loadDataStudent, { data: dataStudent }] = useLazyQuery(STUDENTS, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    const fetch = async () => {
      if (dataStudent?.students) {
        if (dataStudent?.students?.data?.length > 0) {
          await localStorage.setItem(
            USER_DATA_KEY,
            JSON.stringify(dataStudent?.students?.data[0]?.studentType)
          );
          if (dataStudent?.students?.data[0]?.statusStep !== "SAVED" && dataStudent?.students?.data[0]?.statusStep !== "REJECTED") {
            history.push(
              `/cardstudent/${dataStudent?.students?.data[0]?.code}`
            );
            setIsLoading(false);
          }
          if (
            dataStudent?.students?.data[0]?.studentType !== "IN_PLAN" &&
            dataStudent?.students?.data[0]?.studentType !== "OUT_PLAN"
          ) {
            setIsLoading(false);
            history.push(`/registrationStudent`, {
              studentType: dataStudent?.students?.data[0]?.studentType,
            });
          }
        } else {
          // if (studentTypeForm === "OUT_PLAN" || studentTypeForm === "IN_PLAN") {
          // history.push(`/registrationStudent`, { studentType: studentTypeForm })
          // setIsLoading(false)
          // } else {
          setIsLoading(false);
          //   setErrorStudentType(true)
          // }
        }
      }
    };
    fetch();
  }, [dataStudent]);

  const _login = async (values) => {
    if (!phone && !code) return;
    try {
      setIsLoading(true);
      const responseData = await login({
        variables: {
          data: loginType === "PHONE" ? {
            phoneNumber: "856" + phone,
            code: ""
          } : {
            code: code
          }
        }
      })
      const data = responseData?.data?.login
      // setStudentTypeForm(responseData?.data?.login?.studentType)
      // if (responseData?.data?.login?.studentType !== typeForm) {
      //   setErrorMessage("LOGIN_IS_NOT_FORMATTED")
      setIsLoading(false);
      //   return null
      // }
      await localStorage.setItem(USER_KEY, JSON.stringify(data));
      await loadDataStudent({
        variables: {
          where: { code: data?.code, assessmentYear: assessmentYearNow },
        },
      });
    } catch (error) {
      setIsLoading(false);
      setErrorMessage(error.message);
    }
  };

  const _onEnterKey = async (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (!phone && !code) return;
      try {
        setIsLoading(true);
        const dataForm = loginType === "PHONE" ? {
          phoneNumber: "856" + phone,
          code: ""
        } : {
          code: code
        }
        const responseData = await login({
          variables: {
            data: dataForm
          }
        })
        const data = responseData?.data?.login
        // setStudentTypeForm(responseData?.data?.login?.studentType)
        // if (responseData?.data?.login?.studentType !== typeForm) {
        setErrorMessage("LOGIN_IS_NOT_FORMATTED");
        setIsLoading(false);
        // return null
        // }
        await localStorage.setItem(USER_KEY, JSON.stringify(data));
        await loadDataStudent({
          variables: {
            where: { code: data?.code, assessmentYear: assessmentYearNow },
          },
        });
      } catch (error) {
        setIsLoading(false);
        setErrorMessage(error.message);
      }
    }
  };

  const _handleChangePhone = async (e) => {
    setPhone(e.target.value);
  };
  const _handleChangeCode = async (e) => {
    setCode(e.target.value);
  };

  const _handleClickOutPlan = () => {
    history.push(`/registrationStudent`, { studentType: "OUT_PLAN" });
  };
  const _handleClickInPlan = () => {
    history.push(`/registrationStudent`, { studentType: "IN_PLAN" });

    // setShowModalCloseRegister(true)
  };
  if (isLoading) return <Loading />;
  return (
    <div style={{ background: "#F5F5F5", minHeight: "100vh" }}>
      <BrowserView>
        <div
          className="textfont-size20"
          style={{
            paddingRight: 24,
            paddingTop: 24,
            position: "fixed",
            right: 0,
          }}
        >
          ມີ​ບັນ​ຫາ​ເຂົ້າ​ສູ່​ລະ​ບົບ?{" "}
          <span
            style={{ color: "#0d6efd" }}
            onClick={() => setShowDanger(true)}
          >
            ຊ່ວຍ​ເຫຼືອ
          </span>
        </div>
        <div
          className="textfont-size24 text-center"
          style={{ marginBottom: 41 }}
        >
          <img className="logo" src={logo} />
          <br />
          ມະຫາວິທະຍາໄລ ຈຳປາສັກ
        </div>
        <div className="d-flex justify-content-center">
          {dataStudent?.students ? (
            <div
              style={{
                backgroundColor: "#fff",
                padding: 30,
                paddingLeft: 80,
                paddingRight: 80,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                // className='d-flex justify-content-center'
                style={{ cursor: "pointer" }}
                onClick={() => _handleClickOutPlan()}
              >
                <div style={{ cursor: "pointer" }} className="login2">
                  <div className="col-sm-9">
                    <div className="textfont-size26 colorWhite">
                      ລົງທະບຽນເຂົ້າຮຽນ
                    </div>
                    <div className="textfont-size30 text-bold colorWhite">
                      ສ​ຳລັບນັກ​ສຶກ​ສານອກແຜນ
                    </div>
                  </div>
                  <div
                    style={{
                      textAlign: "right",
                      marginTop: 20,
                      marginLeft: 30,
                    }}
                    className="col-sm-1 colorWhite"
                  >
                    <FontAwesomeIcon icon={faSignInAlt} size="3x" />
                  </div>
                </div>
              </div>

              <div
                // className='d-flex justify-content-center'
                onClick={() => _handleClickInPlan()}
              >
                <div style={{ cursor: "pointer" }} className="login1">
                  <div className="col-sm-9">
                    <div className="textfont-size26 colorWhite">
                      ລົງທະບຽນເຂົ້າຮຽນ
                    </div>
                    <div className="textfont-size30 text-bold colorWhite">
                      ສ​ຳລັບນັກ​ສຶກ​ສາໃນແຜນ
                    </div>
                  </div>
                  <div
                    style={{ textAlign: "right", marginLeft: 30 }}
                    className="col-sm-1 colorWhite"
                  >
                    <FontAwesomeIcon icon={faSignInAlt} size="3x" />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{
                backgroundColor: "#fff",
                padding: 30,
                paddingLeft: 80,
                paddingRight: 80,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <h2>
                <b>ກະລຸນາລ໊ອກອິນເພື່ອເຂົ້າໃຊ້ລະບົບ</b>
              </h2>

              <Form
                noValidate
                style={{
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <div>
                  <div
                    className="d-flex justify-content-center"
                    style={{ marginBottom: 20 }}
                  >
                    <div>
                      <Form.Group>
                        <Form.Check
                          inline
                          label="ເຂົ້າດ້ວຍເບີໂທລະສັບ"
                          type="radio"
                          value="PHONE"
                          id="phone-radio"
                          name="phone"
                          checked={loginType === "PHONE"}
                          onChange={() => setLoginType("PHONE")}
                        />
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group>
                        <Form.Check
                          inline
                          label="ເຂົ້າດ້ວຍລະຫັດສອບເສັງ"
                          type="radio"
                          value="CODE"
                          id="phone-radio"
                          name="code"
                          checked={loginType === "CODE"}
                          onChange={() => setLoginType("CODE")}
                        />
                      </Form.Group>
                    </div>
                  </div>
                  <Form.Group as={Row} controlId="formPlaintextEmail">
                    <Form.Label
                      column
                      sm="2"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                        marginTop: -7,
                      }}
                    >
                      {loginType === "PHONE" ? (
                        <div
                          style={{
                            border: "1px #cbcbcbff solid",
                            width: "100%",
                            paddingTop: "6px",
                            paddingBottom: "6px",
                            borderRadius: "5px",
                          }}
                        >
                          +85620
                        </div>
                      ) : (
                        <FontAwesomeIcon
                          icon={faUser}
                          size="2x"
                          color="#057CAE"
                        />
                      )}
                    </Form.Label>
                    {loginType === "PHONE" ? (
                      <Col sm="8" style={{ marginBottom: 27 }}>
                        <Form.Control
                          name="phone"
                          type="text"
                          maxLength={8}
                          pattern="[+-]?\d+(?:[.,]\d+)?"
                          placeholder="xxxxxxxx"
                          onChange={(e) => _handleChangePhone(e)}
                          onKeyDown={(e) => _onEnterKey(e)}
                          value={phone}
                        />
                        {errorMessage ? (
                          <span style={{ color: "#CC0000", fontSize: 14 }}>
                            {errorMessage ===
                              "GraphQL error: THE_CODE_CAN_NOT_FOUND" ||
                              errorMessage ===
                              "GraphQL error: Cannot return null for non-nullable field Mutation.login."
                              ? "* ເບີໂທລະສັບບໍ່ຖືກຕ້ອງ, ກະລຸນາລອງໃໝ່ອີກຄັ້ງ"
                              : ""}
                            {errorMessage === "LOGIN_IS_NOT_FORMATTED"
                              ? "* ເບີໂທລະສັບນີ້ບໍ່ຕົງກັບແບບຟອມນີ້, ກະລຸນາເລືອກ​ຮູບ​ແບບ​ການ​ເຂົ້າ​ສູ່​ລະ​ບົບໃຫ້ຖືກຕ້ອງ"
                              : ""}
                          </span>
                        ) : (
                          ""
                        )}
                        {errorStudentType ? (
                          <span style={{ color: "#CC0000", fontSize: 14 }}>
                            <br />* ເບີໂທລະສັບນີ້ໃຊ້ບໍ່ໄດ້ກັບແບບຟອມນີ້.
                            <br />
                            ກະລຸນາເລືອກແບບຟອມໃຫ້ຖືກຕ້ອງ ແລ້ວລອງໃໝ່ອີກຄັ້ງ.
                          </span>
                        ) : (
                          <></>
                        )}
                      </Col>
                    ) : (
                      <Col sm="8" style={{ marginBottom: 27 }}>
                        <Form.Control
                          name="code"
                          type="text"
                          placeholder="ໃສ່ລະຫັດສອບເສັງ"
                          onChange={(e) => _handleChangeCode(e)}
                          onKeyDown={(e) => _onEnterKey(e)}
                          value={code}
                        />
                        {errorMessage ? (
                          <span style={{ color: "#CC0000", fontSize: 14 }}>
                            {errorMessage ===
                              "GraphQL error: THE_CODE_CAN_NOT_FOUND" ||
                              errorMessage ===
                              "GraphQL error: Cannot return null for non-nullable field Mutation.login."
                              ? "* ລະຫັດສອບເສັງບໍ່ຖືກຕ້ອງ, ກະລຸນາລອງໃໝ່ອີກຄັ້ງ"
                              : ""}
                            {errorMessage === "LOGIN_IS_NOT_FORMATTED"
                              ? "* ລະຫັດສອບເສັງນີ້ບໍ່ຕົງກັບແບບຟອມນີ້, ກະລຸນາເລືອກ​ຮູບ​ແບບ​ການ​ເຂົ້າ​ສູ່​ລະ​ບົບໃຫ້ຖືກຕ້ອງ"
                              : ""}
                          </span>
                        ) : (
                          ""
                        )}
                        {errorStudentType ? (
                          <span style={{ color: "#CC0000", fontSize: 14 }}>
                            <br />* ລະຫັດນີ້ໃຊ້ບໍ່ໄດ້ກັບແບບຟອມນີ້.
                            <br />
                            ກະລຸນາເລືອກແບບຟອມໃຫ້ຖືກຕ້ອງ ແລ້ວລອງໃໝ່ອີກຄັ້ງ.
                          </span>
                        ) : (
                          <></>
                        )}
                      </Col>
                    )}
                    <Col sm="2"></Col>
                    <Col sm="1"></Col>
                    <Col sm="9">
                      <Button
                        style={{
                          width: "97%",
                          backgroundColor: "#057CAE",
                          marginTop: 24,
                          marginLeft: 15,
                        }}
                        type="button"
                        onClick={() => _login()}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              width: "100%",
                              fontSize: 20,
                            }}
                          >
                            ລ໊ອກອິນ
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              width: 30,
                              alignItems: "flex-end",
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faSignInAlt}
                              style={{ fontSize: 24, fontWeight: "normal" }}
                              color="#fff"
                            />
                          </div>
                        </div>
                      </Button>
                    </Col>
                  </Form.Group>
                </div>
              </Form>
              {loginType === "PHONE" ? (
                <div
                  className="textfont-size18 bottomleft"
                  style={{ marginTop: 45, fontSize: 14 }}
                >
                  ໝາຍເຫດ: ເລກໂທລະສັບ ແມ່ນ ເລກໂທລະສັບລົງທະບຽນສອບເສັງຂອງຕົນ
                  <br />
                  ຕົວຢ່າງ: 98493843
                </div>
              ) : (
                <div
                  className="textfont-size18 bottomleft"
                  style={{ marginTop: 45, fontSize: 14 }}
                >
                  ໝາຍເຫດ: ລະຫັດ ແມ່ນ ລະຫັດເຂົ້າຫ້ອງສອບເສັງຂອງຕົນ
                  <br />
                  ຕົວຢ່າງ: A0214, SEA0214, ATA0214, SAA0214…
                </div>
              )}
            </div>
          )}
        </div>
      </BrowserView>

      <MobileView>
        <div className="d-flex justify-content-center">
          <div style={{ textAlign: "center" }}>
            <img width="99px" src={logo} />
          </div>
        </div>
        <div
          style={{
            marginBottom: 41,
            marginTop: 10,
            fontSize: 12,
            textAlign: "center",
          }}
        >
          ມະຫາວິທະຍາໄລ ຈຳປາສັກ
          <br />
          Champasack University
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            backgroundColor: "#F5F5F5",
          }}
        >
          <Formik
            initialValues={{
              code: "",
            }}
            onSubmit={async (values) => {
              _login(values);
            }}
          >
            {({ handleSubmit }) => (
              <div>
                <div>
                  {dataStudent?.students ? (
                    <div
                      style={{
                        width: 100 + "%",
                        backgroundColor: "#fff",
                        padding: 20,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        className="d-flex justify-content-center"
                        onClick={() => _handleClickOutPlan()}
                      >
                        <div
                          className="loginMobileViewOutPlan col-12"
                          style={{ cursor: "pointer" }}
                        >
                          <div className="col-10">
                            <div className="textfont-size12 colorWhite">
                              ລົງທະບຽນເຂົ້າຮຽນ
                            </div>
                            <div className="textfont-size16 text-bold colorWhite">
                              ສ​ຳລັບນັກ​ສຶກ​ສານອກແຜນ
                            </div>
                          </div>
                          <div
                            style={{ textAlign: "right" }}
                            className="col-2 colorWhite"
                          >
                            <FontAwesomeIcon icon={faSignInAlt} size="2x" />
                          </div>
                        </div>
                      </div>
                      <div
                        className="d-flex justify-content-center mt-3"
                        onClick={() => _handleClickInPlan()}
                      >
                        <div
                          style={{ cursor: "pointer" }}
                          className="loginMobileViewInPlan col-12"
                        >
                          <div className="col-10">
                            <div className="textfont-size12 colorWhite">
                              ລົງທະບຽນເຂົ້າຮຽນ
                            </div>
                            <div className="textfont-size16 text-bold colorWhite">
                              ສ​ຳລັບນັກ​ສຶກ​ສາໃນແຜນ
                            </div>
                          </div>
                          <div
                            style={{ textAlign: "right", marginTop: 10 }}
                            className="col-2 colorWhite"
                          >
                            <FontAwesomeIcon icon={faSignInAlt} size="2x" />
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      style={{
                        width: 300,
                        backgroundColor: "#fff",
                        padding: 20,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <b>ກະລຸນາລ໊ອກອິນເພື່ອເຂົ້າໃຊ້ລະບົບ</b>

                      <div style={{ marginTop: 10 }}>
                        <div>
                          <Form.Group>
                            <Form.Check
                              inline
                              label="ລ໊ອກອິນດ້ວຍເບີໂທລະສັບ"
                              type="radio"
                              value="PHONE"
                              id="phone-radio"
                              name="phone"
                              checked={loginType === "PHONE"}
                              onChange={() => setLoginType("PHONE")}
                            />
                          </Form.Group>
                        </div>
                        <div>
                          <Form.Group>
                            <Form.Check
                              inline
                              label="ລ໊ອກອິນດ້ວຍລະຫັດສອບເສັງ"
                              type="radio"
                              value="CODE"
                              id="phone-radio"
                              name="code"
                              checked={loginType === "CODE"}
                              onChange={() => setLoginType("CODE")}
                            />
                          </Form.Group>
                        </div>
                      </div>
                      <Form
                        noValidate
                        style={{
                          justifyContent: "center",
                        }}
                      >
                        <Form.Group controlId="formPlaintextEmail">
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: 20, marginRight: 10 }}>
                              <FontAwesomeIcon
                                icon={faUser}
                                size="2x"
                                color="#057CAE"
                              />
                            </div>
                            {loginType === "PHONE" ? (
                              <div style={{ marginTop: 20 }}>
                                <Form.Control
                                  style={{ fontSize: 14 }}
                                  name="phone"
                                  type="text"
                                  placeholder="ໃສ່ເບີໂທ 20 xx xxx xxx"
                                  onChange={(e) => _handleChangePhone(e)}
                                  onKeyDown={(e) => _onEnterKey(e)}
                                  value={phone}
                                />
                                {errorMessage ? (
                                  <span
                                    style={{ color: "#CC0000", fontSize: 10 }}
                                  >
                                    {errorMessage ===
                                      "GraphQL error: THE_CODE_CAN_NOT_FOUND" ||
                                      errorMessage ===
                                      "GraphQL error: Cannot return null for non-nullable field Mutation.login."
                                      ? "* ເບີໂທລະສັບບໍ່ຖືກຕ້ອງ, ກະລຸນາລອງໃໝ່ອີກຄັ້ງ"
                                      : ""}
                                    {errorMessage === "LOGIN_IS_NOT_FORMATTED"
                                      ? "* ເບີໂທລະສັບນີ້ບໍ່ຕົງກັບແບບຟອມນີ້, ກະລຸນາເລືອກ​ຮູບ​ແບບ​ການ​ເຂົ້າ​ສູ່​ລະ​ບົບໃຫ້ຖືກຕ້ອງ"
                                      : ""}
                                  </span>
                                ) : (
                                  ""
                                )}
                                {errorStudentType ? (
                                  <span
                                    style={{ color: "#CC0000", fontSize: 14 }}
                                  >
                                    <br />* ເບີໂທນີ້ໃຊ້ບໍ່ໄດ້ກັບແບບຟອມນີ້.
                                    <br />
                                    ກະລຸນາເລືອກແບບຟອມໃຫ້ຖືກຕ້ອງ
                                    ແລ້ວລອງໃໝ່ອີກຄັ້ງ.
                                  </span>
                                ) : (
                                  <></>
                                )}
                              </div>
                            ) : (
                              <div style={{ marginTop: 20 }}>
                                <Form.Control
                                  style={{ fontSize: 14 }}
                                  name="code"
                                  type="text"
                                  placeholder="ໃສ່ລະຫັດສອບເສັງ"
                                  onChange={(e) => _handleChangeCode(e)}
                                  onKeyDown={(e) => _onEnterKey(e)}
                                  value={code}
                                />
                                {errorMessage ? (
                                  <span
                                    style={{ color: "#CC0000", fontSize: 10 }}
                                  >
                                    {errorMessage ===
                                      "GraphQL error: THE_CODE_CAN_NOT_FOUND" ||
                                      errorMessage ===
                                      "GraphQL error: Cannot return null for non-nullable field Mutation.login."
                                      ? "* ລະຫັດສອບເສັງບໍ່ຖືກຕ້ອງ, ກະລຸນາລອງໃໝ່ອີກຄັ້ງ"
                                      : ""}
                                    {errorMessage === "LOGIN_IS_NOT_FORMATTED"
                                      ? "* ລະຫັດສອບເສັງນີ້ບໍ່ຕົງກັບແບບຟອມນີ້, ກະລຸນາເລືອກ​ຮູບ​ແບບ​ການ​ເຂົ້າ​ສູ່​ລະ​ບົບໃຫ້ຖືກຕ້ອງ"
                                      : ""}
                                  </span>
                                ) : (
                                  ""
                                )}
                                {errorStudentType ? (
                                  <span
                                    style={{ color: "#CC0000", fontSize: 14 }}
                                  >
                                    <br />* ລະຫັດນີ້ໃຊ້ບໍ່ໄດ້ກັບແບບຟອມນີ້.
                                    <br />
                                    ກະລຸນາເລືອກແບບຟອມໃຫ້ຖືກຕ້ອງ
                                    ແລ້ວລອງໃໝ່ອີກຄັ້ງ.
                                  </span>
                                ) : (
                                  <></>
                                )}
                              </div>
                            )}
                          </div>

                          <div>
                            <Button
                              style={{
                                width: "100%",
                                backgroundColor: "#057CAE",
                                marginTop: 45,
                                height: 40,
                              }}
                              onClick={() => handleSubmit()}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "center",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    width: "100%",
                                    fontSize: 12,
                                  }}
                                >
                                  ລ໊ອກອິນ
                                </div>
                                <div>
                                  <FontAwesomeIcon
                                    icon={faSignInAlt}
                                    style={{
                                      fontSize: 24,
                                      fontWeight: "normal",
                                    }}
                                    color="#fff"
                                  />
                                </div>
                              </div>
                            </Button>
                          </div>
                        </Form.Group>
                      </Form>

                      <div>
                        {loginType === "PHONE" ? (
                          <div style={{ marginTop: 34, fontSize: 12 }}>
                            ໝາຍເຫດ: ເລກໂທລະສັບ ແມ່ນ
                            ເລກໂທລະສັບລົງທະບຽນສອບເສັງຂອງຕົນ
                            <br />
                            ຕົວຢ່າງ: 20 xx xxx xxx
                          </div>
                        ) : (
                          <div style={{ marginTop: 34, fontSize: 12 }}>
                            ໝາຍເຫດ: ລະຫັດ ແມ່ນ ລະຫັດເຂົ້າຫ້ອງສອບເສັງຂອງຕົນ
                            <br />
                            ຕົວຢ່າງ: A0214, SEA0214, ATA0214, SAA0214…
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </Formik>
          <div style={{ fontSize: 14, textAlign: "center", marginTop: 75 }}>
            ມີ​ບັນ​ຫາ​ເຂົ້າ​ສູ່​ລະ​ບົບ?{" "}
            <span
              style={{ color: "#0d6efd" }}
              onClick={() => setShowModalMobile(true)}
            >
              ຊ່ວຍ​ເຫຼືອ
            </span>
          </div>
        </div>
        <Modal
          show={showModalMobile}
          onHide={() => setShowModalMobile(false)}
          animation={false}
        >
          <Modal.Header className="borderModalLoginMobile">
            <div>ຕິດ​ຕໍ່​ພວກ​ເຮົາ</div>
          </Modal.Header>
          <Modal.Body
            style={{
              color: "#707070",
              textAlign: "center",
              fontSize: 12,
              fontWeight: "bold",
            }}
          >
            <p>ຊ່ອງ​ທາງ​ໃນ​ການຕິດ​ຕໍ່​​ພວກ​ເຮົາ​</p>
            <p>ເບີ​ໂທ​ລະ​ສັບ: 021 771 989</p>
            <p>ວິຊາການ ມຈ: 020 5445 6359, 020 5252 2266</p>
            <p>ອີ​ເມວ: info.01slms@gmail.com</p>
            <p>ໝາຍເຫດ: ຕິດຕໍ່ໄດ້ພາຍໃນໂມງລາດຊະການເທົ່ານັ້ນ </p>
            <img src={pngkit_call} style={{ width: 120, height: 79 }} />
          </Modal.Body>
        </Modal>
      </MobileView>

      <Modal
        show={showDanger}
        onHide={() => setShowDanger(false)}
        animation={false}
      >
        <Modal.Header className="borderModalLogin">
          <div>ຕິດ​ຕໍ່​ພວກ​ເຮົາ</div>
        </Modal.Header>
        <Modal.Body
          style={{
            color: "#707070",
            textAlign: "center",
            fontSize: 20,
            fontWeight: "bold",
          }}
        >
          <p>ຊ່ອງ​ທາງ​ໃນ​ການຕິດ​ຕໍ່​​ພວກ​ເຮົາ​</p>
          <p>ເບີ​ໂທ​ລະ​ສັບ:</p>
          <p>021 771 989</p>
          <p>ວິຊາການ ມຈ:</p>
          <p>020 5445 6359</p>
          <p>020 5252 2266</p>
          <p>ອີ​ເມວ:</p>
          <p>info.01slms@gmail.com</p>
          <p>ໝາຍເຫດ: ຕິດຕໍ່ໄດ້ພາຍໃນໂມງລາດຊະການເທົ່ານັ້ນ </p>
          <img src={pngkit_call} style={{ width: 190, height: 121 }} />
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Form_login;
